// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"443":"497d7f2b","787":"82387d49"}[chunkId] + ".chunk.js";
};